import { observer } from 'mobx-react';
import { ShareableLink } from '../../../Types';
import Body from './Body';

interface Props {
  programFamilyShareUrls: ShareableLink[];
}

function sortByShareUrlName(a: ShareableLink, b: ShareableLink) {
  return a.name.text.localeCompare(b.name.text);
}

function LinkRow({ programFamilyShareUrls }: Props) {
  return [...programFamilyShareUrls]
    .sort(sortByShareUrlName)
    .map((programFamilyShareUrl) => (
      <Body
        programFamilyShareUrl={programFamilyShareUrl}
        key={programFamilyShareUrl.shareUrl.payload.id}
      />
    ));
}

export default observer(LinkRow);
